<template>
  <div class="popin" :class="['popin--' + position]" v-click-outside="hide">
    <slot></slot>
  </div>
</template>
<script>
import vClickOutside from "click-outside-vue3";

export default {
  name: "Popin",
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    position: {
      type: String,
      default: "center",
      required: false
    },
    positionY: {
      type: String,
      default: "top",
      required: false
    }
  },
  created() {},
  methods: {
    hide() {
      this.$emit('hide');
    }
  }
};
</script>
<style lang="scss" scoped>
.popin {
  @include elevated;
  @include border-radius;
  background-color: $background-color-base;
  padding: $space-s $space-m;
  position: relative;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.13);
  top: $space-s;
  z-index: 1000;
  &:before,
  &:after {
    border: solid transparent;
    content: " ";
    height: 0;
    pointer-events: none;
    position: absolute;
    width: 0;
    border-width: 8px;
    bottom: 100%;
    left: 50%;
    border-bottom-color: #e8e8e8;
    margin-left: -8px;
  }

  &:after {
    border-bottom-color: $color-neutral-100;
    border-width: 7px;
    margin-left: -7px;
  }

  &--right {
    &:before,
    &:after {
      left: 90%;
    }
  }

  &--left {
    &:before,
    &:after {
      left: 10%;
    }
  }

  &--y-bottom {
    &:before,
    &:after {
      bottom: auto;
      top: -10px;
    }
  }
}
</style>
